import './signed-out.css';
import React, { useEffect } from 'react';
import { Translate, Storage } from 'react-jhipster';
import { DropdownItem } from 'reactstrap';
import TranslateIcon from '@mui/icons-material/Translate';
import WebFont from 'webfontloader';
import { isRTL, languages, locales } from 'app/config/translation';
import { setLocale } from 'app/shared/reducers/locale';
import { NavDropdown } from 'app/shared/layout/menus/menu-components';
import { useAppDispatch } from 'app/config/store';

export const BoubyanSignedOut = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Inria Sans'],
      },
    });
  }, []);

  const handleLocaleChange = event => {
    const langKey = event.target.value;
    document.querySelector('html').setAttribute('dir', isRTL(langKey) ? 'rtl' : 'ltr');
    Storage.session.set('locale', langKey);
    dispatch(setLocale(langKey));
  };

  return (
    <div className="boubyan-signed-out">
      <div className="bso-topbar">
        <img className="bso-logo" src="content/images/boubyan-logo.png" alt="Boubyan Capital" />
        <NavDropdown
          icon="language"
          name={
            <div className="bso-lang">
              <TranslateIcon sx={{ fontSize: '20px' }} />
              <Translate contentKey="global.menu.language" />
            </div>
          }
        >
          {locales.map(locale => (
            <DropdownItem key={locale} value={locale} onClick={handleLocaleChange}>
              {languages[locale].name}
            </DropdownItem>
          ))}
        </NavDropdown>
      </div>

      <div className="bso-main">
        <div className="bso-card">
          <div className="bso-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </div>

          <h1 className="bso-title">
            <Translate contentKey="boubyanSignedOut.title">Thank You</Translate>
          </h1>
          <p className="bso-lede">
            <Translate contentKey="boubyanSignedOut.lede">
              {"You've been signed out of your "}
              <strong>Boubyan Capital</strong>
              {' quotation.'}
            </Translate>
          </p>

          <div className="bso-note">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10Z" />
            </svg>
            <p>
              <Translate contentKey="boubyanSignedOut.note">To view your quotation again, use the SMS link we sent you.</Translate>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoubyanSignedOut;
